import React, { useEffect, useState } from "react"
import { Col, Row, Card } from "antd"
import styles from "./style.module.css"
import { Link, RouteComponentProps, useHistory, useLocation } from "react-router-dom"
import WhatsappSvg from "./svgs/WhatsappSvg"
import InstagramSvg from "./svgs/InstagramSvg"
import TelegramSvg from "./svgs/TelegramSvg2"
import FacebookSvg from "./svgs/FacebookSvg"
import EmailSvg from "./svgs/EmailSvg"
import CustomSvg from "./svgs/CustomSvg"
import smsImg from "assets/images/channels/sms.png"

import MercadoLivreImage from "assets/images/channels/mercado-livre.png"
import cx from "classnames"
import { useStore, useStoreState } from "hooks"
import { CHANNEL_TYPES } from "lib/constants"
import { isAldeia } from "hooks/useAldeia"
import { channelsDef } from "./channels.def"
import { cn } from "lib/utils"
import ChannelCard from "./ChannelCard"
import SettingsPageBreadcrumb from "components-old/common/SettingsPage/SettingsPageBreadcrumb"
import AddChannelWhatsapp from "./AddChannelWhatsApp"
import AddWhatsApp from "./whatsapp/AddWhatsApp"
import { useSetAtom } from "jotai"
import { modalState } from "atoms/app.atom"
import AddTelegram from "./telegram/AddTelegram"
import AddCustom from "./custom/AddCustom"
import AddChannelEmail from "./email/AddChannelEmail"
import AddMetaChannel from "./facebook/AddMetaChannel"
import AddVoip from "./voip/AddVoip"
import AddWhatsappEmbedded from "./whatsapp/embed/AddWhatsappEmbedded"
import { session } from "store"
import AddFacebook from "./facebook/AddFacebook"
import AddInstagram from "./instagram/AddInstagram"
import AddWhatsappCloud from "./whatsappCloud/AddWhatsappCloud"
// import { session, useStore } from "store"

interface IChannelType {
  ComponentSVG?: any
  name?: string
  to?: string
  bg?: string
  logoType?: string
  imgStyle?: any
  disabled?: boolean
  code?: string
  onClick?: () => void
}

function AddChannel(props: RouteComponentProps) {
  const { user } = useStore(session)
  const location = useLocation()

  const isKinboxFacebook = location.pathname.includes("facebook") && !isAldeia
  const isKinboxInstagram = location.pathname.includes("instagram") && !isAldeia

  if (isKinboxFacebook) {
    return <AddFacebook />
  }

  if (isKinboxInstagram) {
    return <AddInstagram />
  }

  return (
    <SettingsPageBreadcrumb
      basePath="/settings/channels/new"
      steps={{
        new: {
          title: "Conectar novo canal",
          backTo: "/settings/channels",
          lastPath: "new",
          helpText: (
            <span>Conecte-se aos aplicativos de mensagens mais usados pelos seus clientes e responda todos em sua caixa de entrada.</span>
          ),
          description: isAldeia
            ? "Escolha um canal de comunicação para integrar a Aldeia"
            : "Escolha um canal de comunicação para integrar ao Kinbox",
          children: <AddChannelContent />,
        },
        whatsapp: {
          title: "WhatsApp",
          backTo: "/settings/channels/new",
          // icon: <IconMageWhatsapp className="size-[22px]" />,
          lastPath: "whatsapp",
          helpText: (
            <span>
              Conecte um canal através do Business API (Oficial), ou através do seu aplicativo lendo um QRCode. Cada tipo tem preço
              diferente.
            </span>
          ),
          description:
            isAldeia && user?.email !== "facebook_test@gmail.com" ? (
              <span>Escolha entre o modo oficial da Meta ou modo Web não oficial lendo um QRCode.</span>
            ) : (
              "Escolha o tipo de canal que deseja conectar"
            ),
          children: <AddChannelWhatsapp />,
        },
        email: {
          title: "E-mail",
          backTo: "/settings/channels/new",
          lastPath: "email",
          helpText: <span>Conecte um canal usando encaminhamento ou por IMAP/SMPT.</span>,
          description: isAldeia ? (
            <span>Escolha o tipo de conexão que deseja usar para conectar seu e-mail.</span>
          ) : (
            "Conecte um canal usando encaminhamento ou por IMAP/SMPT."
          ),
          children: <AddChannelEmail />,
        },
        cloud: {
          title: "Cloud API",
          backTo: "/settings/channels/new/whatsapp",
          lastPath: "cloud",
          helpText: (
            <span>Conecte-se aos aplicativos de mensagens mais usados pelos seus clientes e responda todos em sua caixa de entrada.</span>
          ),
          description: isAldeia ? (
            <span>
              <a
                href="https://kinbox.notion.site/Instala-o-996c0c3974134465ac1a7f239c8f8c0b"
                target="_blank"
                rel="noreferrer"
                className="font-semibold underline"
              >
                {/* <i className="fal fa-lightbulb" style={{ marginRight: 5 }} /> */}
                Clique aqui
              </a>
              {` `}para ver a documentação de como conectar o WhatsApp Cloud API Oficial.
            </span>
          ) : (
            <>
              <p>A API Oficial do WhatsApp agora está disponível para qualquer empresa de qualquer tamanho, grande e pequena.</p>
              <br />
              <p>
                <a
                  href="https://kinbox.notion.site/Instala-o-996c0c3974134465ac1a7f239c8f8c0b"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: "var(--primary)",
                  }}
                >
                  <i className="fal fa-lightbulb" style={{ marginRight: 5 }} />
                  Clique aqui
                </a>
                {` `}para ver a documentação de como conectar.
              </p>
            </>
          ),
          children: <AddWhatsappCloud />,
        },
        web: {
          title: "Web",
          backTo: "/settings/channels/new/whatsapp",
          lastPath: "web",
          helpText: (
            <span>Conecte-se aos aplicativos de mensagens mais usados pelos seus clientes e responda todos em sua caixa de entrada.</span>
          ),
          // description: isAldeia ? (
          //   <span>
          //     Evite utilizar uma nova conta (Número novo) para conectar ao WhatsApp Web ou Aldeia. Isso pode levar ao bloqueio do seu número
          //     pelo WhatsApp, pois a plataforma pode confundi-lo com spam. É recomendado "aquecer" o número durante pelo menos uma semana,
          //     trocando mensagens diariamente com outros contatos conhecidos.
          //   </span>
          // ) : (
          //   <>
          //     Evite utilizar uma nova conta (Número novo) para conectar ao WhatsApp Web ou o Kinbox. Isso pode levar ao bloqueio do seu
          //     número pelo WhatsApp, pois a plataforma pode confundi-lo com spam. É recomendado "aquecer" o número durante pelo menos uma
          //     semana, trocando mensagens diariamente com outros contatos conhecidos.
          //   </>
          // ),
          children: <AddWhatsApp />,
        },
        embedded: {
          title: "API Oficial",
          backTo: "/settings/channels/new/whatsapp",
          lastPath: "embedded",
          helpText: (
            <span>Conecte-se aos aplicativos de mensagens mais usados pelos seus clientes e responda todos em sua caixa de entrada.</span>
          ),
          children: <AddWhatsappEmbedded />,
        },
        facebook: {
          title: "Facebook",
          backTo: "/settings/channels/new",
          lastPath: "facebook",
          icon: !isAldeia ? <FacebookSvg /> : <i className="inline-block size-6">{channelsDef.record["facebook"]?.icon}</i>,
          children: !isAldeia ? <AddFacebook /> : <AddMetaChannel type="facebook" />,
        },
        instagram: {
          title: "Instagram",
          backTo: "/settings/channels/new",
          lastPath: "instagram",
          icon: !isAldeia ? <InstagramSvg /> : <i className="inline-block size-6">{channelsDef.record["instagram"]?.icon}</i>,
          children: <AddMetaChannel type="instagram" />,
        },
      }}
    />
  )
}

const AddChannelContent = () => {
  const channelStore = useStoreState((state) => state.channels)
  const setModal = useSetAtom(modalState)

  const channelsTypes: IChannelType[] = [
    {
      ComponentSVG: WhatsappSvg,
      name: "WhatsApp",
      to: "/settings/channels/new/whatsapp",
      bg: "#3c9040",
      code: CHANNEL_TYPES.WHATSAPP,
    },
    {
      ComponentSVG: FacebookSvg,
      name: "Facebook",
      to: "/settings/channels/new/facebook",
      bg: "#4e71ba",
      code: CHANNEL_TYPES.FACEBOOK,
    },
    {
      ComponentSVG: TelegramSvg,
      name: "Telegram",
      // to: "/settings/channels/new/telegram",
      bg: "#058dd0",
      code: CHANNEL_TYPES.TELEGRAM,
      onClick: () => {
        setModal(<AddTelegram />)
      },
    },
    {
      ComponentSVG: EmailSvg,
      name: "E-mail",
      to: "/settings/channels/new/email",
      bg: "#eabc0c",
      code: CHANNEL_TYPES.EMAIL,
    },
    {
      ComponentSVG: InstagramSvg,
      name: "Instagram",
      to: "/settings/channels/new/instagram",
      bg: "#ffc3d6",
      code: CHANNEL_TYPES.INSTAGRAM,
    },
    ...(isAldeia
      ? []
      : [
          {
            ComponentSVG: MercadoLivreImage,
            name: "Mercado livre",
            to: "/settings/channels/new/mercado-livre",
            logoType: "image",
            imgStyle: { borderRadius: "50%" },
            bg: "#ffe503",
            code: CHANNEL_TYPES.MERCADO_LIVRE,
          },
        ]),
    {
      ComponentSVG: smsImg,
      logoType: "image",
      name: "SMS",
      to: "/settings/channels/new/sms",
      bg: "#262525",
      disabled: !!channelStore.all.find((x) => x.channelId == CHANNEL_TYPES.SMS),
      code: CHANNEL_TYPES.SMS,
    },
    {
      ComponentSVG: CustomSvg,
      name: "Customizado",
      // to: "/settings/channels/new/custom",
      bg: "#262525",
      code: CHANNEL_TYPES.CUSTOM,
      onClick: () => {
        setModal(<AddCustom />)
      },
    },
    // ...(isAldeia
    //   ? [
    //       {
    //         ComponentSVG: CustomSvg,
    //         name: "Voip",
    //         // to: "/settings/channels/new/custom",
    //         bg: "#262525",
    //         code: CHANNEL_TYPES.VOIP,
    //         onClick: () => {
    //           setModal(<AddVoip />)
    //         },
    //       },
    //     ]
    //   : []),
  ]

  return (
    <div className={cn(isAldeia && "grid grid-cols-[repeat(auto-fit,_minmax(160px,_1fr))] gap-2")}>
      {channelsTypes
        .sort((a, b) => {
          if (a.disabled && !b.disabled) return 1
          if (!a.disabled && b.disabled) return -1
          return 0
        })
        .map((channelType, index) => {
          const def = channelsDef.recordByCode[channelType.code || ""]

          return (
            <ChannelCard
              key={channelType.name}
              to={channelType.to || ""}
              onClick={channelType.onClick}
              disabled={channelType.disabled}
              icon={
                isAldeia ? (
                  <>
                    <div className="size-11">{def?.icon}</div>
                  </>
                ) : (
                  <>
                    {channelType.logoType == "image" ? (
                      <img src={channelType.ComponentSVG} alt="" style={channelType.imgStyle} />
                    ) : (
                      <channelType.ComponentSVG />
                    )}
                  </>
                )
              }
              name={channelType.name || ""}
              index={index}
            />
          )
        })}
    </div>
  )
}

export default AddChannel
